// src/utils/navGuard.js
// Lets a page (e.g. Pick Team with unsaved changes) intercept in-app navigation
// from the shared nav components (BottomNav, Layout menu, LeagueNav).
import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

let _guard = null; // (proceed: () => void) => void

export function setNavGuard(fn) {
  _guard = typeof fn === "function" ? fn : null;
}

// Drop-in replacement for useNavigate() in nav components.
export function useGuardedNavigate() {
  const navigate = useNavigate();
  const location = useLocation();
  return useCallback(
    (to, opts) => {
      const go = () => navigate(to, opts);
      const samePath = typeof to === "string" && to === location.pathname;
      if (_guard && !samePath) _guard(go);
      else go();
    },
    [navigate, location.pathname]
  );
}
